
/* injects from baggage-loader */

'use strict';

import footerModule from './core/components/footer/footer.module';
import headerModule from './core/components/header/header.module';
import summaryModule from './auth/components/summary/summary.module';
import officeSearchModule from './core/components/officeSearch/officeSearch.module';
import sellerCashierSearchModule from './core/components/sellerCashierSearch/sellerCashierSearch.module';
import sellerSearchModule from './core/components/sellerSearch/sellerSearch.module';
import cashierSearchModule from './core/components/cashierSearch/cashierSearch.module';
import lockUnlockFiltersModule from './core/components/lockUnlockFilters/lockUnlockFilters.module';
import fileManagementFiltersModule from './core/components/fileManagementFilters/fileManagementFilters.module';

/**
 * Modules used with common components in the web application.
 */
export default angular.module('index.components', [
	footerModule.name,
	headerModule.name,
	summaryModule.name,
	officeSearchModule.name,
	sellerCashierSearchModule.name,
	sellerSearchModule.name,
	cashierSearchModule.name,
	lockUnlockFiltersModule.name,
	fileManagementFiltersModule.name
]);



// WEBPACK FOOTER //
// ./src/app/index.components.js